// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_ao-0";
export var optionCard = "_ao-1";